var update = require("!../../node_modules/style-loader/lib/addStyleUrl.js")(
  require("!!../../node_modules/file-loader/dist/cjs.js!./tabs.css")
, {"hmr":true});
if(module.hot) {
  module.hot.accept("!!../../node_modules/file-loader/dist/cjs.js!./tabs.css", function() {
    update(require("!!../../node_modules/file-loader/dist/cjs.js!./tabs.css"));
  });

  module.hot.dispose(function() { update(); });
}